export default {
	namespaced: true,
	state: {
		/*运维大屏模板 地图样式 下标从1开始 直接传入模板id*/
		mouldMapStyle: [{},{
			id: 1,
			style: 'amap://styles/70a5900951dd748d19d4ebcab7033c52',
		},{
			id: 2,
			style: 'amap://styles/70a5900951dd748d19d4ebcab7033c52',
		},{
			id: 3,
			style: 'amap://styles/70a5900951dd748d19d4ebcab7033c52',
		},{
			id: 4,
			style: 'amap://styles/426a981026cfad65a0d6041c0558b1a1',
		},{
			id: 5,
			style: 'amap://styles/426a981026cfad65a0d6041c0558b1a1',
		},{
			id: 6,
			style: 'amap://styles/426a981026cfad65a0d6041c0558b1a1',
		}],
		
		/*系统属性列表*/
		system_options: [{
			id: '_company_total',
			name: '总数'
		},{
			id: '_company_newly',
			name: '新增'
		},{
			id: '_company_online',
			name: '在线'
		},{
			id: '_company_stop',
			name: '停用'
		},{
			id: '_user_total',
			name: '总数'
		},{
			id: '_user_newly',
			name: '新增'
		},{
			id: '_user_online',
			name: '在线'
		},{
			id: '_user_stop',
			name: '停用'
		},{
			id: '_user_freeze',
			name: '冻结'
		},{
			id: '_alarm_total',
			name: '总数'
		},{
			id: '_alarm_level_infor',
			name: '提示数量'
		},{
			id: '_alarm_level_warm',
			name: '警告数量'
		},{
			id: '_alarm_level_error',
			name: '故障数量'
		},{
			id: '_fault_response_time',
			name: '响应时间'
		},{
			id: '_fault_recovery_time',
			name: '恢复时间'
		},{
			id: '_device_total',
			name: '总数'
		}],
				
		/*规定大屏模板数组  (用于遍历)
		 * 数据项array的顺序
		 */
		mouldBox: [
			'leftOne', 
			'leftTwo', 
			'leftThree', 
			'rightOne', 
			'rightTwo', 
			'rightThree', 
			'center', 
			'centerBottom', 
			'rightOneByOne', 
			'rightOneByTwo', 
			'rightOneByThree', 
			'rightOneByFour',
			'leftOneByOne', 
			'leftOneByTwo',
			'leftOneByThree', 
			'leftOneByFour',
			'centerTopByOne', 
			'centerTopByTwo',
			'centerTopByThree', 
			'centerTopByFour',
		],
		
		/*int型 定义柱状图 折线图 实时数据下只展示多少条*/
		ChartsDataLength: 8,
		NewChartsDataLength: 12,
		
	}, //结束定义state

	getters: {

	}, //结束定义getters

	mutations: {
		
	}, //结束创建方法
}


// WEBPACK FOOTER //
// ./src/vueX/model/defaultChartsOptions.js